import { Link } from "react-router-dom";
import team1 from "../../assets/images/all-img/v4/team1.png";
import team10 from "../../assets/images/all-img/v4/team10.png";
import team11 from "../../assets/images/all-img/v4/team11.png";
import team12 from "../../assets/images/all-img/v4/team12.png";
import team2 from "../../assets/images/all-img/v4/team2.png";
import team3 from "../../assets/images/all-img/v4/team3.png";
import team4 from "../../assets/images/all-img/v4/team4.png";
import team5 from "../../assets/images/all-img/v4/team5.png";
import team6 from "../../assets/images/all-img/v4/team6.png";
import team7 from "../../assets/images/all-img/v4/team7.png";
import team8 from "../../assets/images/all-img/v4/team8.png";
import team9 from "../../assets/images/all-img/v4/team9.png";
import facebook from "../../assets/images/social2/facebook.svg";
import github from "../../assets/images/social2/github.svg";
import instagram from "../../assets/images/social2/instagram.svg";
import twitter from "../../assets/images/social2/twitter.svg";
 
export default function TeamSection() {
	return (
		<div className="fugu--team-section fugu--team-two dark-version">
			<div className="row">
				<div className="col-lg-3 col-md-6">
					<div className="fugu--team-wrap wow fadeInUpX" data-wow-delay="0s">
						<div className="fugu--team-thumb">
							<img src={team1} alt="" />
						</div>
						<div className="fugu--team-data">
							<h4>Eleanor Pena</h4>
							<p>CEO & 3D Designer</p>
							<div className="fugu--social-icon">
								<ul>
									<li>
										<Link to={"#"}>
											<img src={twitter} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={facebook} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={instagram} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={github} alt="" />
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-3 col-md-6">
					<div className="fugu--team-wrap wow fadeInUpX" data-wow-delay=".10s">
						<div className="fugu--team-thumb">
							<img src={team2} alt="" />
						</div>
						<div className="fugu--team-data">
							<h4>Arlene McCoy</h4>
							<p>Marketing Officer</p>
							<div className="fugu--social-icon">
								<ul>
									<li>
										<Link to={"#"}>
											<img src={twitter} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={facebook} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={instagram} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={github} alt="" />
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-3 col-md-6">
					<div className="fugu--team-wrap wow fadeInUpX" data-wow-delay=".20s">
						<div className="fugu--team-thumb">
							<img src={team3} alt="" />
						</div>
						<div className="fugu--team-data">
							<h4>Kathryn Murphy</h4>
							<p>Operating Officer</p>
							<div className="fugu--social-icon">
								<ul>
									<li>
										<Link to={"#"}>
											<img src={twitter} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={facebook} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={instagram} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={github} alt="" />
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-3 col-md-6">
					<div className="fugu--team-wrap wow fadeInUpX" data-wow-delay=".30s">
						<div className="fugu--team-thumb">
							<img src={team4} alt="" />
						</div>
						<div className="fugu--team-data">
							<h4>Jerome Bell</h4>
							<p>Art Director</p>
							<div className="fugu--social-icon">
								<ul>
									<li>
										<Link to={"#"}>
											<img src={twitter} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={facebook} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={instagram} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={github} alt="" />
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-3 col-md-6">
					<div className="fugu--team-wrap wow fadeInUpX" data-wow-delay=".40s">
						<div className="fugu--team-thumb">
							<img src={team5} alt="" />
						</div>
						<div className="fugu--team-data">
							<h4>Theresa Webb</h4>
							<p>Marketing manager</p>
							<div className="fugu--social-icon">
								<ul>
									<li>
										<Link to={"#"}>
											<img src={twitter} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={facebook} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={instagram} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={github} alt="" />
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-3 col-md-6">
					<div className="fugu--team-wrap wow fadeInUpX" data-wow-delay=".50s">
						<div className="fugu--team-thumb">
							<img src={team6} alt="" />
						</div>
						<div className="fugu--team-data">
							<h4>Marvin McKinney</h4>
							<p>Senior developer</p>
							<div className="fugu--social-icon">
								<ul>
									<li>
										<Link to={"#"}>
											<img src={twitter} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={facebook} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={instagram} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={github} alt="" />
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-3 col-md-6">
					<div className="fugu--team-wrap wow fadeInUpX" data-wow-delay=".60s">
						<div className="fugu--team-thumb">
							<img src={team7} alt="" />
						</div>
						<div className="fugu--team-data">
							<h4>Darrell Steward</h4>
							<p>Senior consultant</p>
							<div className="fugu--social-icon">
								<ul>
									<li>
										<Link to={"#"}>
											<img src={twitter} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={facebook} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={instagram} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={github} alt="" />
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-3 col-md-6">
					<div className="fugu--team-wrap wow fadeInUpX" data-wow-delay=".70s">
						<div className="fugu--team-thumb">
							<img src={team8} alt="" />
						</div>
						<div className="fugu--team-data">
							<h4>Devon Lane</h4>
							<p>Art Director</p>
							<div className="fugu--social-icon">
								<ul>
									<li>
										<Link to={"#"}>
											<img src={twitter} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={facebook} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={instagram} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={github} alt="" />
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-3 col-md-6">
					<div className="fugu--team-wrap wow fadeInUpX" data-wow-delay=".80s">
						<div className="fugu--team-thumb">
							<img src={team9} alt="" />
						</div>
						<div className="fugu--team-data">
							<h4>Floyd Miles</h4>
							<p>WP Developer</p>
							<div className="fugu--social-icon">
								<ul>
									<li>
										<Link to={"#"}>
											<img src={twitter} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={facebook} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={instagram} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={github} alt="" />
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-3 col-md-6">
					<div className="fugu--team-wrap wow fadeInUpX" data-wow-delay=".90s">
						<div className="fugu--team-thumb">
							<img src={team10} alt="" />
						</div>
						<div className="fugu--team-data">
							<h4>Kristin Watson</h4>
							<p>Marketing Officer</p>
							<div className="fugu--social-icon">
								<ul>
									<li>
										<Link to={"#"}>
											<img src={twitter} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={facebook} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={instagram} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={github} alt="" />
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-3 col-md-6">
					<div className="fugu--team-wrap wow fadeInUpX" data-wow-delay="1s">
						<div className="fugu--team-thumb">
							<img src={team11} alt="" />
						</div>
						<div className="fugu--team-data">
							<h4>Jacob Jones</h4>
							<p>Operating Officer</p>
							<div className="fugu--social-icon">
								<ul>
									<li>
										<Link to={"#"}>
											<img src={twitter} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={facebook} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={instagram} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={github} alt="" />
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-3 col-md-6">
					<div className="fugu--team-wrap wow fadeInUpX" data-wow-delay="1.10s">
						<div className="fugu--team-thumb">
							<img src={team12} alt="" />
						</div>
						<div className="fugu--team-data">
							<h4>Esther Howard</h4>
							<p>Art Director</p>
							<div className="fugu--social-icon">
								<ul>
									<li>
										<Link to={"#"}>
											<img src={twitter} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={facebook} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={instagram} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={github} alt="" />
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="fugu--team-button">
				<Link to={"#"}>
					<a className="fugu--btn bg-gray active">Join Our Team</a>
				</Link>
			</div>
		</div>
	);
}
